import type { Organization } from './organization';

export enum RepCodeState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export type RepCode = {
  id?: string;
  code?: string;
  name?: string;
  archived?: boolean;
  state?: RepCodeState;
  organization?: Organization;
};
